import { render } from "./PageC.vue?vue&type=template&id=61af545e"
import script from "./PageC.vue?vue&type=script&lang=js"
export * from "./PageC.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__